const driver = typeof window !== 'undefined' ? window.sessionStorage : null;

export const sessionStorageService = {
  get(key: string): string | null {
    if (!driver) return null;
    try {
      return driver.getItem(key);
    } catch {
      return null;
    }
  },

  set(key: string, value: string) {
    if (!driver) return;
    try {
      driver.setItem(key, value);
    } catch {}
  },

  remove(key: string) {
    if (!driver) return;
    try {
      driver.removeItem(key);
    } catch {}
  },

  has(key: string) {
    if (!driver) return false;
    try {
      return driver.getItem(key) !== null;
    } catch {
      return false;
    }
  },
};

export default sessionStorageService;
